import React, { KeyboardEventHandler, MouseEventHandler } from 'react';
import { PopoverTrigger } from '@spotify-internal/encore-web/core';

import { NavBarSecondaryLinksPopoverOverlay } from 'components/Masthead/Header/Popover/SecondaryLinksOverlay';
import { MastheadLinkList } from 'lib/sanity/types';
import useDropdown from 'components/Masthead/Header/hooks/useDropdown';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';

export const NavBarSecondaryLinksPopover = ({
  linkListEntry,
  children,
}: {
  linkListEntry: MastheadLinkList;
  children: ({
    label,
    onMouseDown,
    onKeyDown,
  }: {
    label: string;
    onMouseDown: MouseEventHandler;
    onKeyDown: KeyboardEventHandler;
  }) => JSX.Element;
}) => {
  const { handlers, open } = useDropdown(linkListEntry.label);
  const { isLoggedIn } = useServerSideConstants();
  const ubi = useUbiMastheadHeader();

  const onKeyDown: KeyboardEventHandler = e => {
    ubi.logSecondaryButtonInteraction({ expanded: !open, identifier: linkListEntry.trackingID });
    handlers.handleOnKeyDown(e);
  };

  const onMouseDown: MouseEventHandler = e => {
    ubi.logSecondaryButtonInteraction({ expanded: !open, identifier: linkListEntry.trackingID });
    handlers.handleOnMouseDown(e);
  };

  return (
    <PopoverTrigger
      onShow={() => {}}
      onHide={() => {}}
      onMouseEnter={handlers.handleOnMouseEnter}
      onMouseLeave={handlers.handleOnMouseLeave}
      placement="bottomStart"
      overlay={open && <NavBarSecondaryLinksPopoverOverlay isLoggedIn={isLoggedIn} linkListEntry={linkListEntry} />}
    >
      {children({ label: linkListEntry.label, onMouseDown, onKeyDown })}
    </PopoverTrigger>
  );
};
